import _isEmpty from 'lodash/isEmpty';
import { safeJsonStringify } from '../utils/json';

export function addSearchParamsInRoute(route: string, searchParams: Record<string, unknown>) {
  // using the fake domain to create a URL object
  const url = new URL(route, 'http://localhost');

  Object.entries(searchParams).forEach(([key, value]) => {
    if (!_isEmpty(value)) {
      url.searchParams.set(key, typeof value === 'string' ? value : safeJsonStringify(value, ''));
    }
  });

  return `${url.pathname}${url.search}`;
}
